function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.8894 1.23307C12.1647 0.437929 11.1702 0 10.0891 0C9.28096 0 8.54086 0.258457 7.88931 0.768132C7.56055 1.0254 7.26265 1.34015 7 1.70752C6.73746 1.34026 6.43945 1.0254 6.11058 0.768132C5.45914 0.258457 4.71904 0 3.9109 0C2.82976 0 1.83524 0.437929 1.11052 1.23307C0.394455 2.01893 0 3.09252 0 4.25622C0 5.45396 0.441238 6.55035 1.38855 7.70671C2.23599 8.74108 3.45396 9.79111 4.86441 11.007C5.34602 11.4222 5.89194 11.8929 6.45879 12.3943C6.60854 12.527 6.80069 12.6 7 12.6C7.1992 12.6 7.39146 12.527 7.541 12.3945C8.10785 11.893 8.65408 11.4221 9.13591 11.0067C10.5461 9.79101 11.7641 8.74108 12.6116 7.7066C13.5589 6.55035 14 5.45396 14 4.25611C14 3.09252 13.6055 2.01893 12.8894 1.23307Z",
  fill: "white"
});

var SvgHeart = function SvgHeart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHeart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/heart.9628d875.svg";
export { ForwardRef as ReactComponent };